import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconDesktop = createIcon({
  displayName: 'IconDesktop',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M2 18H22V8H20V16H4V6H22V4H2V18ZM7 20H17V22H7V20Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
